// An expired access cookie is removed by the browser. Passport then reports
// "No auth token", even though the persistent refresh cookie is still valid.
export const shouldRefreshSession = (response, user) => {
  if (!response || ![401, 403].includes(response.status)) return false;
  const { name, message } = response.data || {};
  return name === 'TokenExpiredError'
    || message === 'jwt expired'
    || (Boolean(user) && message === 'No auth token');
};

export const isRejectedRefreshSession = error => (
  Boolean(error.response) && [401, 403].includes(error.response.status)
);
